import {Component} from "react";
import Glob from "../../../../../libs/Glob.mjs";
import {Button, ButtonGroup, Col, InputGroup, InputGroupText, Row} from "reactstrap";
import TextLabel from "../../../../../Controls/TextLabel.mjs";
import ReadIcon from "../../../../../media/images/ReadIcon.mjs";
import UserIcon from "../../../../../media/images/UserIcon.mjs";
import AvvisiPreviewRecipients from "../../AvvisiPreviewRecipients.mjs";

const prefix = "AvvisiEditorTo";

const AvvisiEditorTo = class extends Component {
	constructor(props) {
		super(props);
		this.state = { value: (props.message?.to || []) };
		this.uid = Glob.generateUid(prefix);
	}
	render() {
		return(
			<Row className={ this.props.error ? 'select error': 'select'}>
				<Col className={"nomobile"}>
					<TextLabel value={"To"} />
				</Col>
				<Col>
					<InputGroup
						onClick={ this.props.browse }
						style={{ cursor: "pointer" }}
					>
						<InputGroupText style={{flexGrow: "1"}}>
							<TextLabel value={"QtRecipients"} params={{qt: this.state.value.length }}/>
						</InputGroupText>
						<ButtonGroup>
							<Button
								color={"warning"}
								onClick={ e=> {
									e.preventDefault();
									e.stopPropagation();
									this.setState({details: this.state.value});
								} }
							>
								<ReadIcon style={{height:"24px"}}/>
							</Button>
							<Button
								color={"primary"}
							>
								<b><TextLabel value={"Edit"} /> </b>
								<UserIcon style={{height:"24px"}} />
							</Button>
						</ButtonGroup>
					</InputGroup>
				</Col>
				{ this.state.details && (
					<AvvisiPreviewRecipients
						list={this.state.details}
						onClose={()=>{ this.setState({details: false}) }}
					/>
				)}
			</Row>
		)
	}
}

export default AvvisiEditorTo;